

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface IPBillParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
}


export interface IpBill {
  id?:any;
  iPBillDate: any;
  regId: any;
  admissionId: any;
  visitId: any;
  billAmount: any;
  advanceAmount: any;
  netAmount: any;
  createdBy: any;
  createdDate: any;
  tenantId: any;
  branchId: any;
  param?:IPBillParameter[];
  paidAmount:any;
  balanceAmount:any;
  status:any;
  discountPercentage: any;
  discountType: any;
  discountAmount: any;
  taxAmount:any;
  discountServiceWiseTotal:any;
  billTotalAfterDiscount:any;
  billTotalWithAdvance:any;
  billTotalWithGST:any;
  gstPercentage:any;
  roundOff:any;
  billNumber:any;
  notes?:string;
  createdById?:number;
  UpdatedBy?:number;
  UpdatedDate?:any;
  gstType?:string;
  pendingamount?:number
}



export abstract class IPBillData {
  abstract createIPBillMaster(url: string, data: any): Observable<any>;

  abstract ipBillMasterList(url: string): Observable<any[]>;
  abstract list(url: string): Observable<any>;
  abstract updateIPBillMaster(url: string, data: any): Observable<any>;
  abstract cancelBill(url: string, data): Observable<any>;
  abstract searchList(url: string,data:any): Observable<any>;

}
